import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import FloatingWhatsApp from '@/components/feature/FloatingWhatsApp';
import StatsBar from '@/components/feature/StatsBar';
import CTA from '@/components/feature/CTA';
import SectionTitle from '@/components/feature/SectionTitle';
import ScrollReveal from '@/components/feature/ScrollReveal';
import HeroSection from './components/HeroSection';
import SegmentsSection from './components/SegmentsSection';
import ServiceCard from './components/ServiceCard';
import EquipmentCard from './components/EquipmentCard';
import BrandsSection from './components/BrandsSection';
import ProcessStep from './components/ProcessStep';
import DifferentialCard from './components/DifferentialCard';
import RecoverOrReplaceSection from './components/RecoverOrReplaceSection';
import NewComponentsSection from './components/NewComponentsSection';
import { ASSETS } from '@/constants/assets';

const STATS = [
  { value: '+2.000', label: 'Equipamentos atendidos' },
  { value: '+500', label: 'Clientes' },
  { value: 'Desde 2007', label: 'No mercado' },
  { value: 'ISO 9001:2015', label: 'Certificação' },
];

const SERVICES = [
  { icon: 'ri-tools-line', title: 'Recuperação de Cilindros', description: 'Diagnóstico completo, desmontagem, usinagem de precisão, substituição de vedações e testes hidrostáticos em cilindros hidráulicos de todos os portes.' },
  { icon: 'ri-settings-2-line', title: 'Recuperação de Bombas', description: 'Recuperação de bombas de engrenagens, palhetas e pistão com engenharia reversa, balanceamento dinâmico e teste de desempenho em bancada.' },
  { icon: 'ri-restart-line', title: 'Recuperação de Motores Hidráulicos', description: 'Reconstrução de motores hidráulicos orbitais, de pistão e de engrenagens com controle dimensional rigoroso e testes de torque e rotação.' },
  { icon: 'ri-contrast-drop-line', title: 'Recuperação de Válvulas', description: 'Recuperação de válvulas direcionais, de controle de vazão, de pressão e proporcionais com limpeza técnica e calibração em bancada dedicada.' },
  { icon: 'ri-dashboard-3-line', title: 'Recuperação de Redutores', description: 'Manutenção especializada em redutores planetários e industriais com análise de desgaste, substituição de rolamentos e engrenagens.' },
  { icon: 'ri-shapes-line', title: 'Componentes Hidráulicos Novos', description: 'Fornecimento de bombas, motores, válvulas, cilindros, filtros, kits de vedação e diversos componentes hidráulicos novos das principais marcas do mercado, com suporte técnico para especificação da solução ideal.', badge: 'NOVA SOLUÇÃO' },
];

const EQUIPMENTS = [
  { image: ASSETS.equipamentos.escavadeira, name: 'Escavadeiras' },
  { image: ASSETS.equipamentos.retroescavadeira, name: 'Retroescavadeiras' },
  { image: ASSETS.equipamentos.paCarregadeira, name: 'Pás Carregadeiras' },
  { image: ASSETS.equipamentos.motoniveladora, name: 'Motoniveladoras' },
  { image: ASSETS.equipamentos.empilhadeira, name: 'Empilhadeiras' },
  { image: ASSETS.equipamentos.plataformaElevatoria, name: 'Plataformas Elevatórias' },
  { image: ASSETS.equipamentos.guindaste, name: 'Guindastes' },
  { image: ASSETS.equipamentos.munck, name: 'Muncks' },
  { image: ASSETS.equipamentos.florestal, name: 'Máquinas Florestais' },
  { image: ASSETS.equipamentos.agricola, name: 'Máquinas Agrícolas' },
  { image: ASSETS.equipamentos.industrial, name: 'Equipamentos Industriais' },
];

const PROCESS_STEPS = [
  { icon: 'ri-phone-line', title: 'Contato' },
  { icon: 'ri-search-eye-line', title: 'Diagnóstico' },
  { icon: 'ri-tools-line', title: 'Recuperação' },
  { icon: 'ri-test-tube-line', title: 'Testes' },
  { icon: 'ri-truck-line', title: 'Entrega' },
];

const DIFFERENTIALS = [
  { icon: 'ri-brain-line', title: 'Engenharia Especializada', description: 'Equipe com formação em engenharia mecânica e décadas de experiência em sistemas hidráulicos.' },
  { icon: 'ri-shield-check-line', title: 'Qualidade', description: 'Processos certificados ISO 9001. Controle dimensional, testes hidrostáticos e rastreabilidade total.' },
  { icon: 'ri-speed-up-line', title: 'Rapidez', description: 'Foco em reduzir tempo de máquina parada. Diagnóstico ágil e entrega dentro do prazo.' },
  { icon: 'ri-user-heart-line', title: 'Atendimento', description: 'Do pequeno prestador à grande indústria, atendemos com o mesmo respeito e dedicação.' },
  { icon: 'ri-loop-left-line', title: 'Solução Completa', description: 'Recuperação quando viável, componentes novos quando a substituição oferece melhor custo-benefício.' },
];

export default function Home() {
  return (
    <>
      <Header />

      <main>
        {/* 1. Hero — preto */}
        <HeroSection />

        {/* 2. Números — cinza escuro */}
        <StatsBar stats={STATS} />

        {/* 3. Serviços — branco */}
        <section id="servicos" className="py-14 md:py-18 bg-background-50">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <ScrollReveal>
              <SectionTitle
                overline="O que fazemos"
                title="Soluções Hidráulicas"
                description="Recuperação especializada de componentes hidráulicos e fornecimento de componentes novos para máquinas pesadas, equipamentos móveis e aplicações industriais."
              />
            </ScrollReveal>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {SERVICES.map((svc, i) => (
                <ScrollReveal key={i} delay={i * 80}>
                  <ServiceCard icon={svc.icon} title={svc.title} description={svc.description} badge={'badge' in svc ? (svc as { badge: string }).badge : undefined} />
                </ScrollReveal>
              ))}
            </div>
          </div>
        </section>

        {/* 4. Segmentos Atendidos — cinza muito claro */}
        <SegmentsSection />

        {/* 5. Equipamentos — branco */}
        <section id="equipamentos" className="py-14 md:py-18 bg-background-50">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <ScrollReveal>
              <SectionTitle
                overline="Atendemos"
                title="Equipamentos e Máquinas"
                description="Recuperamos sistemas hidráulicos dos principais tipos de máquinas pesadas e equipamentos industriais do mercado."
              />
            </ScrollReveal>
            <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
              {EQUIPMENTS.map((eq, i) => (
                <ScrollReveal key={i} delay={i * 60}>
                  <EquipmentCard image={eq.image} name={eq.name} />
                </ScrollReveal>
              ))}
            </div>
          </div>
        </section>

        {/* 6. Marcas — cinza muito claro */}
        <section id="marcas" className="py-14 md:py-18 bg-background-100">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <ScrollReveal>
              <SectionTitle
                overline="Marcas"
                title="Marcas e Componentes Atendidos"
                description="Recuperamos e fornecemos componentes hidráulicos aplicados nos principais fabricantes de máquinas pesadas e sistemas hidráulicos do mercado."
              />
              <p className="mt-4 text-xs md:text-sm text-foreground-400 leading-relaxed max-w-4xl">
                As marcas apresentadas pertencem aos seus respectivos proprietários e são utilizadas apenas para indicar a compatibilidade e experiência da DURAFLOW com equipamentos e componentes amplamente utilizados pelo mercado. A exibição dessas marcas não implica representação, distribuição ou assistência técnica autorizada.
              </p>
            </ScrollReveal>
            <div className="mt-10">
              <ScrollReveal>
                <BrandsSection />
              </ScrollReveal>
            </div>
          </div>
        </section>

        {/* 7. Componentes Hidráulicos Novos — branco */}
        <NewComponentsSection />

        {/* 8. Processo — cinza muito claro */}
        <section id="processo" className="py-14 md:py-18 bg-background-100">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <ScrollReveal>
              <SectionTitle
                overline="Como funciona"
                title="Nosso Processo de Recuperação"
                description="Um fluxo estruturado em 5 etapas, da primeira consulta até a entrega do componente recuperado e testado."
              />
            </ScrollReveal>
            <div className="mt-10 relative">
              <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-px bg-background-300"></div>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-4">
                {PROCESS_STEPS.map((step, i) => (
                  <ScrollReveal key={i} delay={i * 100}>
                    <ProcessStep step={i + 1} icon={step.icon} title={step.title} />
                  </ScrollReveal>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 9. Diferenciais — branco */}
        <section id="diferenciais" className="py-14 md:py-18 bg-background-50">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <ScrollReveal>
              <SectionTitle
                overline="Por que DURAFLOW"
                title="Diferenciais que Garantem Resultado"
                description="Não somos uma oficina. Somos uma empresa de engenharia focada em disponibilidade operacional."
              />
            </ScrollReveal>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
              {DIFFERENTIALS.map((diff, i) => (
                <ScrollReveal key={i} delay={i * 100}>
                  <DifferentialCard icon={diff.icon} title={diff.title} description={diff.description} />
                </ScrollReveal>
              ))}
            </div>
          </div>
        </section>

        {/* 10. Recuperar ou Substituir — cinza muito claro */}
        <RecoverOrReplaceSection />

        {/* 11. CTA final — preto */}
        <CTA />
      </main>

      <Footer />
      <FloatingWhatsApp />
    </>
  );
}